<div class="recently-printed-batch">
  <div class="back-to-assign-btn-container">
    <app-back-to-assign-btn
      [batch]="batch"
      [batchStatus]="batchStatus"
      [disableBackToAssign]="disableBackToAssign"></app-back-to-assign-btn>
  </div>
  <div class="recently-printed-batch__info">
    <div class="recently-printed-batch__info__name">
      <span class="recently-printed-batch__info__name--value">
        {{ batch.name }}
      </span>
      @if (isTplCarrier) {
        <div>
          <app-3pl-tag [height]="'14px'" [width]="'23px'" [text]="'3PL'"> </app-3pl-tag>
        </div>
      }
    </div>
    @if (batch.failed > 0) {
      <div>
        <div class="recently-printed-batch__info__error">
          {{ displayBatchFailedText(batch.failed) }}
          <span
            class="error-tooltip"
            [matTooltip]="'Failed labels sent back to assign: ' + batchFailures"
            [matTooltipPosition]="'below'"
            matTooltipClass="pdq-mat-tooltip"
            >i</span
          >
        </div>
      </div>
    }
    @if (!isTplCarrier) {
      <div class="recently-printed-batch__info__printed">
        <span class="recently-printed-batch__info__printed--times">
          {{
            batch.printCounter == 0
              ? ' Not printed,'
              : batch.printCounter == 1
                ? ' Printed once,'
                : 'Printed ' + batch.printCounter + ' times,'
          }}&nbsp;
        </span>
        <span class="recently-printed-batch__info__printed--date">
          {{ batch.lastPrint | date: 'MMM	dd, hh:mmaaaaa' }}m
        </span>
      </div>
    }
  </div>
  <div class="recently-printed-batch__actions">
    @for (action of batchActions; track action) {
      <div class="recently-printed-batch__actions__btn">
        <app-batch-action-btn
          [imgSrc]="action.imgSrc"
          [tooltipText]="action.tooltipText"
          (actionClick)="action.action(batch.id)"></app-batch-action-btn>
      </div>
    }
  </div>
</div>
